<template>
  <div class="modal fade" data-backdrop="static" data-keyboard="false" aria-hidden="true" role="dialog" tabindex="-1"
       :id="id">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
        </div>
        <div class="modal-body overflow-x-hidden">
          <form method="post" @submit.prevent=""
                ref="form">
            <p>¿Está seguro de rechazar su participación como revisor en el protocolo?</p>
            <label for="reject_comments"
                   class="d-block font-weight-bold`">Comentarios del revisor:</label>
            <textarea cols="5"
                      rows="5"
                      name="reject_comments"
                      id="reject_comments"
                      class="form-control"
                      placeholder="Comentarios del revisor"
                      required
                      v-model="rejectComments"></textarea>
          </form>
        </div>
        <div class="modal-footer px-2 shadow-none">
          <button class="btn"
                  :class="{ 'bg-danger text-white': okButtonType === 'danger', 'btn-primary': okButtonType !== 'danger' }"
                  type="button" @click="rejectInvitation" :disabled="sending">
            <span class="spinner-border text-yellow-500 spinner-border-sm" role="status" v-if="sending">
              <span class="sr-only">Guardando...</span>
            </span>
            {{ okButtonText }}
          </button>
          <button class="btn btn-light ml-2"
                  data-dismiss="modal"
                  type="button"
                  :disabled="sending"
                  @click="$emit('cancel-button-pressed')">
            {{ cancelButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>1

<script>
  import { mapActions } from 'vuex'
  import 'jquery-validation'
  import { AlertManager } from '../../utils/AlertManager'
  
  export default {
    name: 'RejectReviewerInvitation',
    props: {
      id: {
        required: true,
        type: String,
        default: 'ok-cancel-modal',
      },
      title: {
        required: true,
        type: String,
      },
      okButtonText: {
        type: String,
        default: 'Aceptar',
      },
      okButtonType: {
        type: String,
      },
      cancelButtonText: {
        type: String,
        default: 'Cancelar',
      },
      protocol: Object,
      user: Object,
      committee: Object,
      amendment: Object,
    },
    data () {
      return {
        sending: false,
        rejectComments: '',
      }
    },
    methods: {
      ...mapActions({
        replyInvitation: 'committees/replyInvite',
        replyAmendmentInvitation: 'amendments/replyInvite',
      }),
      
      clear () {
        this.rejectComments = ''
        this.sending        = false
      },
      close () {
        this.clear()
        $(this.$el).modal('hide')
      },
      async rejectInvitation () {
        if ($(this.$refs.form).valid()) {
          this.sending = true
          
          let response
          
          if (this.amendment) {
            response = await this.replyAmendmentInvitation({
              amendment: this.amendment,
              user: this.user,
              comments: this.rejectComments,
              committee: this.committee,
              reply: 'reject',
            })
          }
          else {
            response = await this.replyInvitation({
              protocol: this.protocol,
              user: this.user,
              comments: this.rejectComments,
              committee: this.committee,
              reply: 'reject',
            })
          }
          
          if (response.status === 'error') {
            AlertManager.error(response.error)
          }
          else {
            AlertManager.success(response.message)
            
          }
          
          this.sending = false
          this.close()
          
          this.$emit('close-task')
        }
      },
    },
    mounted () {
      $(this.$refs.form).validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.addClass('invalid-feedback')
          
          if (element.is(':radio')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
        },
        rules: {
          reject_comments: 'required',
        },
        messages: {
          reject_comments: {
            required: 'Este campo es requerido.',
          },
        },
      })
    },
  }
</script>
